import { type JSX } from "react";
import { VerticalSpacing } from "../VerticalSpacing"
import { StepWrapper, StepText, CTextIcon } from "./MarketingSteps.styles"
import { Step3Spacing, TrailSVGStep3 } from "./Step3.styles"

interface Step3Props {
    leftSide: JSX.Element,
    rightSide: JSX.Element
}

export const Step3 = ({ leftSide, rightSide }: Step3Props) => {
    return <Step3Spacing>
        <StepWrapper>
            <TrailSVGStep3 src="/authory_static_files/images/how-it-works/trail_top.svg" />
            <div>
                <StepText>
                    <VerticalSpacing bottom={16}>
                        <CTextIcon>
                            <svg width="24" height="1" viewBox="0 0 24 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <line y1="0.5" x2="24" y2="0.5" stroke="#2E77FF" />
                            </svg>
                            <div>
                                Step 3
                            </div>
                        </CTextIcon>
                    </VerticalSpacing>
                    {leftSide}
                </StepText>
            </div>
            <div>
                {rightSide}
            </div>
        </StepWrapper>
    </Step3Spacing>
}